__turbopack_context__.v({
  "checkbox": "CollapsibleDemoContent-module__i6gCxG__checkbox",
  "code": "CollapsibleDemoContent-module__i6gCxG__code",
  "codeBlock": "CollapsibleDemoContent-module__i6gCxG__codeBlock",
  "codeSection": "CollapsibleDemoContent-module__i6gCxG__codeSection",
  "collapseLabel": "CollapsibleDemoContent-module__i6gCxG__collapseLabel",
  "container": "CollapsibleDemoContent-module__i6gCxG__container",
  "demoSection": "CollapsibleDemoContent-module__i6gCxG__demoSection",
  "expandLabel": "CollapsibleDemoContent-module__i6gCxG__expandLabel",
  "fileRefs": "CollapsibleDemoContent-module__i6gCxG__fileRefs",
  "frame": "CollapsibleDemoContent-module__i6gCxG__frame",
  "toggle": "CollapsibleDemoContent-module__i6gCxG__toggle",
});
